module.exports = __webpack_public_path__ + "img/carac-princ2.642489fa.jpg";